import { autoserialize, autoserializeAs } from 'cerialize';
import { User } from './user';

export class InviteUser {
  @autoserializeAs(User)
  user: User;

  @autoserialize
  roleIds: Array<number>;

  @autoserialize
  tenantIds: Array<number>;

  constructor() {
    this.user = new User();
  }
}
